<ng-container *ngIf="designVersion !== 'v3'">
 <div class="applicants-table-wrapper"
    [style.height]="pageName === 'job-applicants' ? 'calc(100vh - 214px)' : 'calc(100vh - 137px)'">
    <div class="applicants-table-container hpanel">
      <!-- Table Header -->
      <div class="applicants-table-header panel-body">
        <div class="header-cell rank-col">Rank</div>
        <div class="header-cell candidate-col">Candidate</div>
        <div class="header-cell location-col">Title & Location</div>
        <div class="header-cell skills-col">Skills</div>
        <!-- Match % hidden on Candidate Applied — see the V3 badge comment:
             the AI match score is the job owner's evaluation, not shown to
             the side that submitted the candidate. -->
        <div class="header-cell match-col" *ngIf="pageName !== 'candidate-applied'">Match %</div>
        <div class="header-cell engagement-col">Engagement</div>
        <div class="header-cell stage-col" *ngIf="pageName == 'job-applicants' || pageName == 'candidate-applied'">Stage</div>
        <div class="header-cell actions-col">Quick Actions</div>
      </div>

      <div class="col-12" *ngIf="loadAPIcall && response?.length==0">
        <app-common-skeleton [countforView]="4" [NameOftheScreen]="'jobcardlarge'"></app-common-skeleton>
      </div>

      <ng-container *ngIf="response.length > 0; else noResult">
        <!-- Custom Table View for Job Applicants -->
        <div class="applicants-table-body">
          <div class="applicant-row" *ngFor="let item of response; let i = index" [ngClass]="{
                  'disabled': !item.availability || item.status != 'ACTIVE',
                  'featured-background': item?.isFeatured === true}">

        <!-- Rank Column -->
        <div class="table-cell rank-col">
          <div class="rank-circle">{{i + 1}}</div>
        </div>

        <!-- Candidate Column -->
        <div id="job_applicant_profile" class="table-cell candidate-col" (click)="route(item)">
          <div class="candidate-info">
            <div class="candidate-avatar" *ngIf="item?.user?.photo != undefined">
              <img [src]="url + item.user.photo" alt="avatar" (error)="$event.target.style.display='none'">
            </div>
            <div class="candidate-avatar" *ngIf="item?.user?.photo == undefined">
              <div class="avatar-initials" 
                [style.background-color]="getColor(item?.user?.fullname)"
                [style.color]="getFullNameTextColor(item?.user?.fullname)">
                {{getInitials(item?.user?.fullname)}}
              </div>
            </div>
            <div class="candidate-details">
              <div class="candidate-name">{{item?.firstName}} {{item?.lastName}}</div>
              <div class="candidate-title">{{item?.jobTitle || 'Full Stack Engineer'}}</div>
              <div class="candidate-experience">{{item?.totalExperience || 0}}+ Years</div>
            </div>
          </div>
        </div>

        <!-- Title & Location Column -->
        <div class="table-cell location-col">
          <div class="location-info">
            <div class="location-text">
              {{item?.jobTitle}}
            </div>
            <div class="location-text">
              {{item?.city}}<span *ngIf="item?.city && item?.state">, </span>{{item?.state}}
            </div>
            <div class="availability-text">Available: {{item?.availableIn || '2 weeks'}}</div>
            <div class="work-mode-badge" *ngIf="item?.workMode">
              {{item?.workMode}}
            </div>
          </div>
        </div>

        <!-- Skills Column -->
        <div class="table-cell skills-col">
          <div class="skills-container" *ngIf="!item.showAllSkills">
            <span class="skill-tag primary-skill text-primary-2" *ngFor="let skill of item?.primarySkills?.slice(0, 2)">
              {{skill}}
            </span>
            <span id="job_applicant_expand_skills_button text-primary-2" class="skill-count" *ngIf="item?.primarySkills?.length > 2" (click)="toggleSkills(item)">
              +{{item?.primarySkills?.length - 2}}
            </span>
          </div>
          <div class="skills-container expanded" *ngIf="item.showAllSkills">
            <span class="skill-tag primary-skill text-primary-2" *ngFor="let skill of item?.primarySkills">
              {{skill}}
            </span>
            <span class="skill-tag secondary-skill text-primary-2" *ngFor="let skill of item?.secondarySkills">
              {{skill}}
            </span>
            <span id="job_applicant_collapse_skills_button" class="skill-collapse" (click)="toggleSkills(item)">
              Show less
            </span>
          </div>
        </div>

        <!-- Match Column — omitted on Candidate Applied (own submissions) -->
        <div class="table-cell match-col" *ngIf="pageName !== 'candidate-applied'">
          <div class="match-score">
            <span class="match-percent text-primary-2" *ngIf="pageName == 'job-applicants'">
              {{ item.matchingScore != null ? (item.matchingScore % 1 === 0 ? item.matchingScore + '%' : (item.matchingScore | number:'1.2-2') + '%') : '-' }}
            </span>            
            <span class="match-percent text-primary-2" *ngIf="pageName != 'job-applicants'">
              {{ item.score != null ?  item.score + '%' : '-' }}
            </span>            
          </div>
          <img *ngIf="item.matchingScore != null && pageName == 'job-applicants'"
           src="../../../../assets/images/details icon.png" alt="" style="height: 33px; width: 33px; cursor:pointer !important;"
              (click)="openPercentageDetails(item)" >
              
          <img *ngIf="item.score != null && pageName != 'job-applicants'"
           src="../../../../assets/images/details icon.png" alt="" style="height: 33px; width: 33px; cursor:pointer !important;"
              (click)="openPercentageDetails(item)" >
               <!-- (click)="openDetails(item)" -->
        </div>

        <!-- Engagement Column -->
        <div class="table-cell engagement-col">
          <div class="engagement-stats">
            <div [title]="item?.viewedByCount + ' Views'" class="stat-item">
              <ng-icon name="tablerEye"></ng-icon> {{ item?.viewedByCount | compactCount }} Views
            </div>
            <!-- <div class="stat-item">
              <ng-icon name="tablerHeart" [class.liked]="item?.isLiked"></ng-icon> {{item?.likesCount || 0}} Like
            </div> -->

            <!-- Like/Unlike Heart Icon -->
            <div id="candidate_card_small_like_button" class="stat-item" *ngIf="item?.isLiked != null" 
              (click)="like(item)">
              <ng-icon name="tablerHeart" class="pointer md-interaction-element" [ngClass]="item.isLiked ? 'bg-heart liked' : 'icon-prime-color'"></ng-icon>

                <!-- Likes Count and Action -->
                <div id="candidate_card_small_likes_button" class="md-interaction-element" 
                  (click)="goTo(item, 'Clike-like')"
                  *ngIf="item?.isLiked != null && item.createdBy == userId">
                  <span [title]="item.likesCount + ' Likes'" class="blue-color">{{ item.likesCount | compactCount }}</span>
                  <span> Like<span *ngIf="item.likesCount > 1">s</span></span>
                </div>

                <!-- Likes Count for Non-Creators -->
                <div class="md-interaction-element" style="cursor: context-menu;"
                  *ngIf="item?.isLiked != null && item.createdBy != userId">
                  <span [title]="item.likesCount + ' Likes'" class="blue-color">{{ item.likesCount | compactCount }}</span>
                  <span> Like<span *ngIf="item.likesCount > 1">s</span></span>
                </div>
            </div>            
          </div>
        </div>

        <!-- Stage Column — gate parity with candidate-card row-design
             (`!isExcludedStatus && canUpdateStatus !== false`). The previous
             `jobDetails.jobPostedBy==userId` check hid the dropdown for
             recruiter / TA viewers who are *not* the literal poster but
             still have permission to update status (backend signals this
             via `canUpdateStatus`). -->
        <div class="table-cell stage-col" *ngIf="pageName == 'job-applicants' || pageName == 'candidate-applied'">
          <!-- `container="body"` mounts the dropdown menu under <body> so
               it escapes the row's flex layout AND the parent
               `.jc-v3-entity-details-body { overflow-x: hidden; overflow-y: auto }`
               which was clipping the menu (image #50). Same fix used by
               candidate-card row-design at candidate-card.component.html:1001
               and the v3 ctrv3-status-wrapper. -->
          <div class="stage-dropdown" dropdown container="body">
            <button class="stage-btn" dropdownToggle
                    [style.background-color]="getStageStyle(item?.currentStatus || 'APPLIED')?.background"
                    [style.color]="getStageStyle(item?.currentStatus || 'APPLIED')?.color"
                    [style.border]="'1px solid ' + (getStageStyle(item?.currentStatus || 'APPLIED')?.background || '#E5E7EB')">
              {{getStageLabel(item?.currentStatus || 'APPLIED')}}

              <!-- <ng-icon name="tablerChevronDown" class="arrowclasspad" style="margin-top: 2px ma;"
                       *ngIf="!isExcludedStatus(item?.currentStatus) && item?.canUpdateStatus !== false"></ng-icon> -->

   <ng-icon name="tablerChevronDown"  
    style=" font-size: 11px; color: inherit; margin-top: -2px;"></ng-icon>
            </button>

            <ng-container *ngIf="!isExcludedStatus(item?.currentStatus) && item?.canUpdateStatus !== false">
              <ul *dropdownMenu class="dropdown-menu stage-menu" >
                <!-- Click handler calls `validateNegativeStatus` directly,
                     mirroring candidate-card row-design HTML line 1344
                     (see candidate-card-row-design-validateNegativeStatus.md §1).
                     The third arg is the #interviewPayrateTemplate ng-template
                     defined at the bottom of this component so the RTR
                     payrate flow can open it without a @ViewChild lookup. -->
                <!-- Pre-Onboarded / Onboarded stay listed but locked here —
                     those transitions belong to the Contract Manager page.
                     See isStatusLocked() in the component. -->
                <li role="menuitem" *ngFor="let statusData of filterApplicant(item?.currentStatus, item?.nextAllowedStatuses)"
                    [class.gs-status-locked]="isStatusLocked(statusData)"
                    [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                    [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                    (click)="isStatusLocked(statusData) ? $event.stopPropagation() : validateNegativeStatus(statusData, item, interviewPayrateTemplate)" id="{{statusData?.item}}">
                  <a id="{{statusData?.item}}"><ng-icon name="tablerCircle"></ng-icon>&nbsp;
                    {{statusData?.item}}
                  </a>
                </li>
              </ul>
            </ng-container>
          </div>

          <!-- Chain chip — current submitted-for state. Renders the latest hop in
               the chain so reviewers see who currently holds the candidate without
               opening Event Log. Hidden until the chain has a non-seed entry. -->
          <div class="submitted-for-chain-chip" *ngIf="(item?.submittedForChain?.length || 0) > 1"
               [title]="'Latest submission: ' + (getLatestChainEntry(item)?.submittedRate || '') + ' ' + (getLatestChainEntry(item)?.submittedRateType || '')">
            <ng-icon name="tablerSend"></ng-icon>
            <span>Submitted ({{item?.submittedForChain?.length || 0}})</span>
            <span class="chain-rate" *ngIf="getLatestChainEntry(item)?.submittedRate">
              @ {{getLatestChainEntry(item)?.submittedRate}}/{{getLatestChainEntry(item)?.submittedRateType}}
            </span>
          </div>
        </div>

        <!-- Quick Actions Column -->
        <div class="table-cell actions-col">
          <div class="action-buttons">
            <button id="job_applicant_view_profile" class="action-btn" title="View Profile" 
              (click)="route(item)" >
              <ng-icon name="tablerEye"></ng-icon>
            </button>
            <button id="job_applicant_download_resume" class="action-btn" title="Download Resume"
                    *ngIf="item?.resumes?.length > 0"
                    (click)="downloadResume(item)">
              <ng-icon name="tablerDownload"></ng-icon>
            </button>
            <button id="job_applicant_invite" class="action-btn" title="Invite to apply"
              *ngIf="item.createdBy!=userId && pageName !== 'candidates-invited' && pageName !== 'resume-requests' && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
              (click)="invite(item)">
              <ng-icon name="tablerMail"></ng-icon>
            </button>
            
            <!-- <button id="job_applicant_send_message" class="action-btn" title="Send Message"
              (click)="sendMessage(item)">
              <ng-icon name="tablerMessage"></ng-icon>
            </button> -->

            <button id="job_applicant_send_message1" *ngIf="item.chatHistoryCount>0" class="action-btn"
              (click)="sendMessage(item)" title="{{item.nonSeenMessageCount}} Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              <span class="blue-color">{{item.nonSeenMessageCount}} </span>
              
            </button>
            <button id="job_applicant_send_message2" *ngIf="item.createdBy!=userId && item.chatHistoryCount == 0"
              (click)="sendMessage(item)" class="action-btn" title="No Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              
            </button>
            <button *ngIf="item.createdBy==userId && item.chatHistoryCount == 0" class="action-btn"
              title="{{item.nonSeenMessageCount}} Messages">
              <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>

            </button>

            <button  *ngIf="pageName !== 'candidate-applied' && ['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(item?.currentStatus)"
              id="job_applicant_documents_button" class="action-btn" title="Candidate Document" (click)="openDocuments(item)">
              <ng-icon name="tablerFileText"></ng-icon>
              <span *ngIf="item.totalMandatoryDocuments > 0" class="doc-count-badge">{{item.totalMandatoryDocuments}}</span>
            </button>
            <button id="job_applicant_payrate_button" class="action-btn payratebutton" title="Pay Rate"
              *ngIf="appliedJobDetails?.jobPostedBy!=userId && item.createdBy!=userId"
              [disabled]="!['OFFERED','OFFER-ACCEPTED','PRE-ONBOARDED'].includes(item?.currentStatus)"
              (click)="openPayRate(item, interviewPayrateTemplate)">
              <ng-icon name="tablerCash" class="mr-1"></ng-icon>
              Pay Rate
            </button>
            <button id="job_applicant_submit_for_button" class="action-btn submit-for-btn"
              *ngIf="shouldShowSubmitForIcon(item)"
              [disabled]="!canSubmitForUpstream(item)"
              [title]="canSubmitForUpstream(item) ? 'Submit For' : 'Already submitted upstream'"
              (click)="canSubmitForUpstream(item) && openSubmitForModal(item, submitForTemplate)">
              <ng-icon name="tablerSend"></ng-icon>
            </button>
            <button id="job_applicant_more_options_button" class="action-btn"
              title="More Options" dropdown
              *ngIf="pageName == 'job-applicants'">
              <ng-icon name="tablerDots" dropdownToggle></ng-icon>
              <ul *dropdownMenu class="dropdown-menu">
                <li><a id="job_applicant_share_profile_link" (click)="shareProfile(item)">Share Profile</a></li>
                <li><a id="job_applicant_schedule_interview_link" (click)="scheduleInterview(item)">Schedule Interview</a></li>
                <li><a id="job_applicant_add_notes_link" (click)="addNotes(item)">Add Notes</a></li>
              </ul>
            </button>
          </div>
        </div>

        <!-- Timeline Progress Bar -->
        <div class="timeline-progress" *ngIf="showTimeline">
          <div class="timeline-track">
            <ng-container *ngFor="let stage of item?.timelineStages; let i = index; let last = last">
              <div class="timeline-step"
                   [class.completed]="stage.completed"
                   [class.active]="stage.active"
                   [class.negative]="stage.isNegative"
                   [class.terminal]="stage.isTerminal"
                   [class.implied]="stage.isImplied"
                   [class.future]="stage.notion === 'future'"
                   [title]="stage.isImplied && stage.date ? (stage.label + ' - Skipped (reached higher stage on ' + (stage.date | timezoneDate:'dd MMM yyyy') + ')') : (stage.isImplied ? (stage.label + ' - Skipped (implied completion)') : (stage.completed && stage.date ? (stage.label + ' - Completed on ' + (stage.date | timezoneDate:'dd MMM yyyy')) : (stage.label + (stage.activityType ? ' (' + stage.activityType + ')' : ''))))">
                <div class="step-dot">
                  <ng-icon name="tablerCheck" *ngIf="stage.completed && !stage.isTerminal"></ng-icon>
                </div>
                <span class="step-label">
                  {{stage.label}}
                </span>
                <span class="step-date" *ngIf="stage.date">
                  {{stage.date | timezoneDate:'dd MMM yyyy'}}
                </span>
              </div>
              <div class="timeline-connector"
                   *ngIf="!last"
                   [class.completed]="item?.timelineStages[i + 1]?.completed && !stage.isTerminal"
                   [class.negative]="stage.isNegative"></div>
            </ng-container>
          </div>
        </div>

      </div>
    </div>

    <div *ngIf="stopscrollFlag  && response.length > 0" class="caught_up">
      <div class="col-md-12">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             <!-- <ng-icon name="tablerCircleCheck"></ng-icon> -->
      </div>
      <div class="col-md-12">
        <p class="biase"> You've reached the bottom of the page </p>
      </div>
    </div>
  </ng-container>

  <ng-template #noResult>
    <div class="wert" *ngIf="!loadAPIcall || responseReceived">
      <div class="col-md-12 mg-bt-9">
        <ng-icon [name]="noResultSvgType"></ng-icon>
      </div>
      <div class="col-md-12 fig">{{noResultMessage}}</div>
    </div>
  </ng-template>
  </div><!-- End of applicants-table-container -->
  </div><!-- End of applicants-table-wrapper -->
</ng-container>

<ng-container *ngIf="designVersion === 'v3'">
<!-- Per-row disable when candidate is unavailable / blocked / non-active.
     V2 row had this on line 24-26; V3 was missing it, so action buttons
     stayed clickable even when the row showed an "Unavailable" pill. -->
<div class="jc-v3-cand-card" *ngFor="let candidate of response; let i = index"
     [ngClass]="{'disabled': !candidate?.availability || candidate?.status !== 'ACTIVE',
                 'featured-background': candidate?.isFeatured === true}">
  <div class="jc-v3-cand-top">
    <!-- Rank -->
    <div class="jc-v3-c-rank">{{ i + 1 }}</div>

    <!-- Col1: Candidate Owner — the recruiter who owns / submitted this
         candidate (`candidate.user`, a full UserModel). Renders the
         prepared-but-previously-unused `.jc-v3-c-col1` recruiter column
         (job-center-v3.scss:1233). Shown on every tab that flows through
         this component: Applicants, Talent Pool, Marketplace Candidates,
         Resume Requests, Candidates Invited, Candidate Applied. Hidden
         when owner data is absent so we never render an empty avatar. -->
    <div class="jc-v3-c-col1" *ngIf="candidate?.user?.fullname || candidate?.user?.firstName">
      <div class="jc-v3-c-rec-row">
        <img *ngIf="candidate?.user?.photo" class="jc-v3-c-rec-av"
             [src]="getPhotoUrl(candidate.user.photo)" alt="owner"
             (error)="$event.target.style.display='none'">
        <div *ngIf="!candidate?.user?.photo" class="jc-v3-c-rec-av"
             [style.background-color]="getColor(candidate?.user?.fullname || (candidate?.user?.firstName + ' ' + candidate?.user?.lastName))"
             [style.color]="getFullNameTextColor(candidate?.user?.fullname || (candidate?.user?.firstName + ' ' + candidate?.user?.lastName))">
          {{ getInitials(candidate?.user?.fullname || (candidate?.user?.firstName + ' ' + candidate?.user?.lastName)) }}
        </div>
        <div class="jc-v3-c-rec-info" style="flex:1;min-width:0;overflow:hidden;">
          <div class="jc-v3-c-rec-name"
               [title]="candidate?.user?.fullname || (candidate?.user?.firstName + ' ' + candidate?.user?.lastName)">
            {{ candidate?.user?.fullname || (candidate?.user?.firstName + ' ' + candidate?.user?.lastName) }}
          </div>
          <div class="jc-v3-c-rec-role" *ngIf="candidate?.user?.userType"
               [title]="formatUserType(candidate?.user?.userType)">
            {{ formatUserType(candidate?.user?.userType) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Col2: Candidate — name + CID click opens the profile slider -->
    <div class="jc-v3-c-col2">
      <div class="jc-v3-c-name-row">
        <span class="jc-v3-c-name jc-v3-c-name-link"
              (click)="open(candidate); $event.stopPropagation()"
              [title]="candidate?.fullname || candidate?.firstName + ' ' + candidate?.lastName">{{ candidate?.fullname || candidate?.firstName + ' ' + candidate?.lastName }}</span>
        <span class="jc-v3-c-cid jc-v3-c-cid-link" *ngIf="candidate?.candidateReferenceId"
              (click)="open(candidate); $event.stopPropagation()"
              [title]="candidate?.candidateReferenceId">{{ candidate?.candidateReferenceId }}</span>
        <!-- Candidate-availability badge — mirrors candidate-card row-design
             at candidate-card.component.html:1194-1197 (placement next to
             the candidate identity, color via the shared status palette).
             Labels follow the V2 `large` view mapping (ACTIVE → Available,
             INACTIVE → Unavailable, BLOCKED → Blocked, DRAFTED → Draft) so
             the displayed text matches what the rest of the product uses. -->
        <span class="jc-v3-c-cand-status" *ngIf="getCandidateStatusLabel(candidate?.status)"
              [style.background-color]="getStageStyle(candidate?.status)?.background"
              [style.color]="getStageStyle(candidate?.status)?.color">
          {{ getCandidateStatusLabel(candidate?.status) }}
        </span>
      </div>
      <div class="jc-v3-c-title jc-v3-c-title-link"
           [title]="candidate?.jobTitle"
           (click)="open(candidate); $event.stopPropagation()">{{ candidate?.jobTitle }}</div>
      <div class="jc-v3-c-exp">{{ candidate?.totalExperience }}+ Years Experience</div>
      <div class="jc-v3-c-meta">
        <div class="jc-v3-c-mi" *ngIf="candidate?.city || candidate?.state">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
          {{ candidate?.city }}<ng-container *ngIf="candidate?.state">, {{ candidate?.state }}</ng-container>
        </div>
      </div>
      <div class="jc-v3-c-foot">
        <span class="jc-v3-c-pill jc-v3-c-pill-p" *ngIf="candidate?.workMode">{{ candidate?.workMode }}</span>
        <span class="jc-v3-c-avail-now" *ngIf="candidate?.availableIn === 'Immediate'" style="font-size:10px;display:flex;align-items:center;gap:3px;">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          Immediate
        </span>
        <span class="jc-v3-c-avail-soon" *ngIf="candidate?.availableIn && candidate?.availableIn !== 'Immediate'" style="font-size:10px;display:flex;align-items:center;gap:3px;">
          <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#D97706" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          {{ candidate?.availableIn }}
        </span>
      </div>
    </div>

    <!-- Col3: Skills — primary first, then secondary; collapsed to 5 until
         the user clicks "+N more". Primary and secondary share one chip
         style (wireframe parity: all purple, no gray differentiation). -->
    <div class="jc-v3-c-col3">
      <div class="jc-v3-c-skills">
        <span class="jc-v3-skill-tag"
              *ngFor="let skill of (candidate.showAllSkills ? getAllCandidateSkills(candidate) : getAllCandidateSkills(candidate).slice(0, 5))">
          {{ skill }}
        </span>
        <span class="jc-v3-skill-more"
              *ngIf="getAllCandidateSkills(candidate).length > 5"
              (click)="toggleSkills(candidate); $event.stopPropagation()">
          <ng-container *ngIf="!candidate.showAllSkills">+{{ getAllCandidateSkills(candidate).length - 5 }} more</ng-container>
          <ng-container *ngIf="candidate.showAllSkills">Show less</ng-container>
        </span>
      </div>
    </div>

    <!-- Col4: Match + Actions. On Resume Requests the match badge is hidden
         (no AI matching), which left the invite button + action row floating
         at the top — the modifier stretches the column and packs them to the
         bottom so they line up with the other tabs. -->
    <div class="jc-v3-c-col4"
         [class.jc-v3-c-col4--bottom]="pageName === 'resume-requests' || pageName === 'candidate-applied'">
      <!-- Invitation-status pill — V2 parity (candidate-card.component.html:414-429
           non-dropdown `status-button-v2` shown when `showStatus=false`).
           Restored on V3 Candidates Invited / Resume Requests tabs which
           dropped the badge entirely; uses currentStatus-driven label so
           INITIATED → "Invited", ACCEPTED → "Applied". Colors come from
           `getStageStyle()` so the pill matches the FormValidation palette
           used everywhere else (Applied = green, Rejected = red, etc.). -->
      <span class="jc-v3-status-pill jc-v3-c-invite-pill"
            *ngIf="pageName === 'candidates-invited' && candidate?.currentStatus"
            [style.background-color]="getStageStyle(candidate?.currentStatus)?.background"
            [style.color]="getStageStyle(candidate?.currentStatus)?.color"
            [style.border-color]="getStageStyle(candidate?.currentStatus)?.background">
        {{ getInvitedStatusLabel(candidate?.currentStatus) }}
      </span>
      <!-- Resume Requests — V2 vocabulary (candidate-job-details RESUME_SENT):
           INITIATED → amber "Resume pending", COMPLETED / RESUME_UPDATED →
           "Resume attached". Status resolved from resumeRequestLogs (per-job)
           / resumeRequestStatus — these rows carry no `currentStatus`. -->
      <span class="jc-v3-status-pill jc-v3-c-invite-pill"
            *ngIf="pageName === 'resume-requests' && getResumeRequestStatus(candidate)"
            [style.background-color]="getResumeRequestStatusStyle(getResumeRequestStatus(candidate))?.background"
            [style.color]="getResumeRequestStatusStyle(getResumeRequestStatus(candidate))?.color"
            [style.border-color]="getResumeRequestStatusStyle(getResumeRequestStatus(candidate))?.background">
        {{ getResumeRequestStatusLabel(getResumeRequestStatus(candidate)) }}
      </span>
      <!-- AI match score hidden on Resume Requests — no match analysis
           runs for that flow, so the badge only ever showed "-".
           Also hidden on Candidate Applied: that tab lists the candidates
           YOU submitted to someone else's job, and the AI match % is the
           job owner's evaluation — not surfaced to the submitting side. -->
      <div class="jc-v3-c-match-badge"
           *ngIf="pageName !== 'resume-requests' && pageName !== 'candidate-applied'"
           [class.amber]="!isCeipalFreePlan && matchTier(candidate) === 'amber'"
           [class.red]="!isCeipalFreePlan && matchTier(candidate) === 'red'"
           [class.no-score]="isCeipalFreePlan || (candidate?.score || candidate?.matchingScore) == null"
           style="cursor:pointer;"
           (click)="isCeipalFreePlan ? showCeipalFreePopup() : openMatch(candidate, $event)"
           title="View AI match insights">
        <div class="jc-v3-c-match-pct"
             [class.amber]="!isCeipalFreePlan && matchTier(candidate) === 'amber'"
             [class.red]="!isCeipalFreePlan && matchTier(candidate) === 'red'">
          <ng-container *ngIf="!isCeipalFreePlan && (candidate?.score || candidate?.matchingScore) != null; else noMatchPct">
            {{ candidate?.score || candidate?.matchingScore }}%
          </ng-container>
          <ng-template #noMatchPct>-</ng-template>
        </div>
        <div class="jc-v3-c-match-lbl"
             [class.amber]="!isCeipalFreePlan && matchTier(candidate) === 'amber'"
             [class.red]="!isCeipalFreePlan && matchTier(candidate) === 'red'">
          Match
          <svg class="jc-v3-c-match-arrow" width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <line x1="7" y1="17" x2="17" y2="7"/>
            <polyline points="7 7 17 7 17 17"/>
          </svg>
        </div>
      </div>

      <!-- Invite to Apply — Talent Pool, Marketplace Candidates and Resume
           Requests (V2 parity: the medium card showed Invite on resume
           requests too). Hidden on Applicants / Job Invites where the
           candidate is already in an interaction with this job. -->
      <button class="jc-v3-btn jc-v3-btn-primary jc-v3-btn-sm jc-v3-c-apply-btn"
        *ngIf="(pageName === 'talent-pool' || pageName === 'suggested-candidates' || pageName === 'resume-requests') && candidate?.createdBy != userId && (userType == 'RECRUITER' || userType == 'FREELANCE_RECRUITER' || userType == 'MANAGEMENT_TALENT_ACQUISITION')"
        [class.disabled]="!candidate?.availability || candidate?.status !== 'ACTIVE'"
        (click)="invite(candidate); $event.stopPropagation()">
        Invite to Apply
      </button>

      <div class="jc-v3-c-act-row">
        <!-- Views: owner = clickable, non-owner = display only (row-design behaviour) -->
        <div class="jc-v3-c-eng-item" *ngIf="candidate?.createdBy == userId" style="cursor:pointer;">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          <span [title]="candidate?.viewedByCount + ' Views'" class="blue-color" *ngIf="candidate?.viewedByCount > 0" (click)="goTo(candidate, 'views')">{{ candidate?.viewedByCount | compactCount }}</span>
          <span class="blue-color" *ngIf="!candidate?.viewedByCount" (click)="goTo(candidate, 'Noviews')">0</span>
        </div>
        <div class="jc-v3-c-eng-item" *ngIf="candidate?.createdBy != userId">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
          <span [title]="candidate?.viewedByCount + ' Views'" class="blue-color">{{ candidate?.viewedByCount | compactCount }}</span>
        </div>
        <div class="jc-v3-c-eng-dot"></div>
        <!-- Like: outer click = toggle like, inner count click = navigate (owner only) -->
        <div class="jc-v3-c-eng-item" *ngIf="candidate?.isLiked != null" style="cursor:pointer;" (click)="like(candidate)">
          <svg viewBox="0 0 24 24"
            [attr.fill]="candidate?.isLiked ? '#F43F5E' : 'none'"
            [attr.stroke]="candidate?.isLiked ? '#F43F5E' : 'currentColor'" stroke-width="2">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
          </svg>
          <span [title]="candidate?.likesCount + ' Likes'" class="blue-color" *ngIf="candidate?.createdBy == userId" (click)="goTo(candidate, 'Clike-like')">
            {{ candidate?.likesCount | compactCount }}
          </span>
          <span [title]="candidate?.likesCount + ' Likes'" class="blue-color" *ngIf="candidate?.createdBy != userId" style="cursor:context-menu;">
            {{ candidate?.likesCount | compactCount }}
          </span>
        </div>
        <!-- Stage column — interactive dropdown for the recruiter viewing
             their own job's applicants; read-only pill for the candidate-side
             viewer (Candidate Applied tab) and for any locked terminal
             status. Mirrors candidate-card.component.html:1302 which already
             handles both `job-applicants` and `candidate-applied`. -->
        <ng-container *ngIf="pageName === 'job-applicants' || pageName === 'candidate-applied'">
          <div class="jc-v3-c-vsep"></div>
          <div class="jc-v3-c-stage-wrap" dropdown *ngIf="pageName === 'job-applicants' && !isExcludedStatus(candidate?.currentStatus) && candidate?.canUpdateStatus !== false">
            <button class="jc-v3-c-stage-sel" dropdownToggle
                    [style.background-color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.background"
                    [style.color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.color"
                    [style.border-color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.background">
              {{ getStageLabel(candidate?.currentStatus || 'APPLIED') }}
              <ng-icon name="tablerChevronDown"
                       
                       style=" font-size: 11px; color: inherit; margin-top: -2px;"></ng-icon>
            </button>
            <ul *dropdownMenu class="dropdown-menu jc-v3-dh-more-dropdown" role="menu">
              <!-- `nextAllowedStatuses` is the server-side role-guard —
                   empty array means view-only; a non-empty array limits
                   the dropdown to transitions the current user is
                   actually permitted to make. V2 template at :161 passes
                   both args; V3 had dropped the second one so users saw
                   every possible next status regardless of permission. -->
              <!-- Pre-Onboarded / Onboarded stay listed but locked here —
                   those transitions belong to the Contract Manager page. -->
              <li role="menuitem" *ngFor="let statusData of filterApplicant(candidate?.currentStatus, candidate?.nextAllowedStatuses)"
                [class.gs-status-locked]="isStatusLocked(statusData)"
                [attr.aria-disabled]="isStatusLocked(statusData) ? true : null"
                [attr.title]="isStatusLocked(statusData) ? 'Managed from Contract Manager' : null"
                (click)="isStatusLocked(statusData) ? $event.stopPropagation() : validateNegativeStatus(statusData, candidate, interviewPayrateTemplate)">
                <a class="dropdown-item">{{ statusData?.item }}</a>
              </li>
            </ul>
          </div>
          <span class="jc-v3-c-stage-sel" *ngIf="pageName === 'candidate-applied' || (pageName === 'job-applicants' && (isExcludedStatus(candidate?.currentStatus) || candidate?.canUpdateStatus === false))"
            style="cursor:default;"
            [style.background-color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.background"
            [style.color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.color"
            [style.border-color]="getStageStyle(candidate?.currentStatus || 'APPLIED')?.background">
            {{ getStageLabel(candidate?.currentStatus || 'APPLIED') }}
          </span>
        </ng-container>
        <!-- Action buttons — ported from baseline V2 row
             (candidate-card-table-view.component.html:179-226). Each
             button mirrors its baseline visibility gate so tabs show
             the same actions they did in V2. -->

        <!-- View Profile (eye) — always visible -->
        <div class="jc-v3-c-ibt" title="View Profile" (click)="open(candidate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
        </div>

        <!-- Download Resume — only when the candidate has at least one
             resume on file. Delegates to the plan-gated flow in
             `downloadResume()` which handles ACTIVE_INTERACTIONS check
             + registered blob download. -->
        <div class="jc-v3-c-ibt" *ngIf="candidate?.resumes?.length > 0"
             title="Download Resume"
             (click)="downloadResume(candidate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
        </div>

        <!-- Chat — 3 variants from baseline :195-210:
             (a) has messages → show with unread count badge,
             (b) non-owner with no history → clickable (start chat),
             (c) owner with no history → display-only (no one to chat with).
             All use `sendMessage()` which goes through the connection
             gate via `openMessagecheckInteraction`, NOT `openMessage`
             directly (baseline parity — previous V3 bypassed the gate). -->
        <div class="jc-v3-c-ibt jc-v3-c-ibt-chat" *ngIf="candidate?.chatHistoryCount > 0"
             [title]="candidate?.nonSeenMessageCount > 0 ? candidate?.nonSeenMessageCount + ' Messages' : 'No Messages'"
             (click)="sendMessage(candidate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          <span class="jc-v3-c-msg-count" *ngIf="candidate?.nonSeenMessageCount > 0">{{ candidate.nonSeenMessageCount }}</span>
        </div>
        <div class="jc-v3-c-ibt" *ngIf="candidate?.createdBy != userId && (candidate?.chatHistoryCount || 0) == 0"
             title="No Messages"
             (click)="sendMessage(candidate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
        <div class="jc-v3-c-ibt jc-v3-c-ibt-static" *ngIf="candidate?.createdBy == userId && (candidate?.chatHistoryCount || 0) == 0"
             title="No Messages">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>

        <!-- Documents — V2 parity (line 230-234). Visible only after the
             candidate has been Offered / Pre-Onboarded / Onboarded; red
             count badge surfaces pending mandatory documents. -->
        <div class="jc-v3-c-ibt"
             *ngIf="pageName !== 'candidate-applied' && ['OFFER-ACCEPTED','PRE-ONBOARDED','ONBOARDED'].includes(candidate?.currentStatus)"
             title="Candidate Document"
             (click)="openDocuments(candidate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          <span class="jc-v3-c-doc-badge" *ngIf="candidate?.totalMandatoryDocuments > 0">{{ candidate.totalMandatoryDocuments }}</span>
        </div>

        <!-- Pay Rate — V2 parity (candidate-card.component.html:1387-1392).
             ngIf gates visibility to non-owner viewers; [disabled] gates
             clickability to status milestones where pay rate is editable. -->
        <button class="jc-v3-c-ibt jc-v3-c-ibt-payrate"
                *ngIf="pageName !== 'resume-requests' && appliedJobDetails?.jobPostedBy!=userId && candidate.createdBy!=userId"
                [disabled]="!['OFFERED','OFFER-ACCEPTED','PRE-ONBOARDED'].includes(candidate?.currentStatus)"
                title="Pay Rate"
                (click)="openPayRate(candidate, interviewPayrateTemplate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>
        </button>

        <!-- Submit For (sub-contracting chain push) — visible to both the current
             chain holder (enabled, clickable) AND past senders who already pushed
             this candidate upstream (disabled, indicator only). Hidden for everyone
             else (job owner, candidate owner, viewers not in chain). -->
        <button class="jc-v3-c-ibt jc-v3-c-ibt-submit-for"
                *ngIf="shouldShowSubmitForIcon(candidate)"
                [disabled]="!canSubmitForUpstream(candidate)"
                [title]="canSubmitForUpstream(candidate) ? 'Submit For' : 'Already submitted upstream'"
                (click)="canSubmitForUpstream(candidate) && openSubmitForModal(candidate, submitForTemplate); $event.stopPropagation()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 2 11 13"/><path d="m22 2-7 20-4-9-9-4 20-7z"/></svg>
        </button>

      </div>
    </div>
  </div>

  <!-- Timeline Progress Bar — verbatim port from candidate-card row-design
       (see candidate-card.component.html:1428-1474). Same classes, same
       property names, same skeleton + actual structure. Driven by
       `candidate.timelineDataGrouped` populated by
       `prepareTimelineForCandidateV3` in the TS. Iterate on the
       `.row-design-timeline-*` SCSS for color tweaks. -->
  <ng-container *ngIf="(pageName === 'job-applicants' || pageName === 'candidate-applied') && candidate?.currentStatus">
    <div class="row-design-timeline-progress" *ngIf="candidate.timelineDataGrouped && candidate.timelineDataGrouped.length > 0">
      <div class="row-design-timeline-track">
        <!-- Continuous gray line behind all dots (matches wireframe .pipe-line) -->
        <div class="row-design-timeline-line"></div>
        <!-- Purple progress overlay — extends to the latest completed dot (positive OR negative) -->
        <div class="row-design-timeline-line-progress"
             [style.width.%]="getProgressLinePct(candidate.timelineDataGrouped)"></div>
        <div class="row-design-timeline-step"
            *ngFor="let stage of candidate.timelineDataGrouped; let i = index"
            [class.completed]="stage.completed"
            [class.current]="stage.completed && !stage.negative && !candidate.timelineDataGrouped[i + 1]?.completed"
            [class.negative]="stage.negative"
            [class.future]="stage.future"
            [title]="stage.isImplied ? '( skipped ) ' + stage.label : stage.label">
          <div class="row-design-step-dot"></div>
          <span class="row-design-step-label">
            {{stage.label}}
          </span>
          <span class="row-design-step-date" *ngIf="stage.date">
            {{stage.date | timezoneDate:'dd MMM yyyy'}}
          </span>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<!-- Unified end-of-list indicator for every V3 sub-tab that renders its list
     through candidate-card-table-view (Applicants / Talent Pool / Marketplace /
     Candidates Invited / Resume Requests). Parents must pass [stopscrollFlag]. -->
<div *ngIf="designVersion === 'v3' && stopscrollFlag && response?.length > 0" class="jc-v3-list-done">
  <ng-icon name="tablerCircleCheck"></ng-icon>
  <p>You've reached the bottom of the page</p>
</div>
</ng-container>

<!-- Message Widget (copied from candidate-card) -->
<app-message-widget
  *ngIf="messagemodelflag"
  (closeMessageModel)="closeMessage($event)"
  [messageDataPass]="messageData">
</app-message-widget>

<app-match-percentage-details
  *ngIf="showPercentageDetails"
  [isOpen]="showPercentageDetails"
  [jobId]="jobDetails.jobId"
  [candidateId]="details.candidateId"
  [pageFrom]="pageName"
  [organisationId]="details.organisationId"
  (close)="closePercentageDetails()">
</app-match-percentage-details>

<!-- ── Rate Confirmation modal — RTR (Right To Represent) form for
     INTERVIEW-SCHEDULED through ONBOARDED status changes. Direct port
     of `candidate-card.component.html#interviewPayrateTemplate` (lines
     2872-2946). The Stage dropdown's click handler passes this template
     ref into `validateNegativeStatus()`, which routes through B2B
     validation and surfaces the modal when the backend OKs the link. ── -->
<ng-template #interviewPayrateTemplate>
  <div class="common-header-flex">
    <div> Rate Confirmation </div>
    <button>
      <span (click)="hidePayrateModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="col-sm-12 p-0">
      <div [formGroup]="rtrformgrp">
        <div class="RtrForm payrate-two-row">

          <div class="payrate-row">
            <div class="payrate-row-label">Submitted for</div>
            <div class="targetRate">
              <input type="text" class="form-control input-sm payrate-readonly"
                     formControlName="submittedToRate" readonly tabindex="-1"
                     placeholder="Ex: 10000.." />
            </div>
            <div class="paytype">
              <select class="form-control input-sm payrate-readonly"
                      formControlName="submittedRateType" disabled tabindex="-1">
                <option [ngValue]="null" disabled hidden>Select Pay Type</option>
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
            </div>
          </div>

          <div class="payrate-row">
            <div class="payrate-row-label">Offer for</div>
            <div class="targetRate">
              <input maxlength="8" (keypress)="isInteger($event)" type="text"
                class="form-control input-sm" formControlName="offerRate" placeholder="Ex: 10000.."/>
              <span *ngIf="rtrFormControls.offerRate.errors?.required &&
                (rtrFormControls.offerRate?.dirty || rtrFormControls.offerRate?.touched || submitRTR)" class="error">Please enter the value</span>
              <span *ngIf="rtrFormControls.offerRate.errors?.invalidDecimal" class="error">Enter valid offer rate</span>
            </div>
            <div class="paytype">
              <select formControlName="offerRateType" class="form-control input-sm">
                <option [ngValue]="null" disabled hidden>Select Pay Type</option>
                <option value="Hourly">Hourly</option>
                <option value="Daily">Daily</option>
                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
                <option value="Yearly">Yearly</option>
              </select>
              <span class="error" *ngIf="rtrFormControls.offerRateType.errors?.required &&
                (rtrFormControls.offerRateType?.dirty || rtrFormControls.offerRateType?.touched || submitRTR)">Please select pay type</span>
            </div>
          </div>

          <div class="tAndCdesign">
            <div class="custom-checkbox em">
              <label class="checkbox-label font-normal" style="text-align: center">
                I confirm the entered pay rate is accurate and approved for this candidate
                <input type="checkbox" class="termsCondition" formControlName="termsandcondition" id="interviewTermsCheckBox" />
                <span class="checkmark"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="t-c-error-msg"
          *ngIf="rtrFormControls.termsandcondition.invalid && (rtrFormControls.termsandcondition.touched || submitRTR)">
          Please acknowledge the rate confirmation to proceed
        </div>
      </div>
    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="hidePayrateModal()">Cancel</button>
        <button class="btn btn-primary" (click)="submitPayrate()">Submit</button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Submit For (sub-contracting chain push) modal — append a SubmittedForEntry
     so the candidate becomes visible to the chosen upstream business. Driven by
     candidate-card-table-view.canSubmitForUpstream() icon visibility. -->
<ng-template #submitForTemplate>
  <div class="common-header-flex">
    <div>Submitted For</div>
    <button>
      <span (click)="closeSubmitForModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="col-sm-12 p-0 white">
    <div class="submit-for-body" [formGroup]="submitForGroup">
      <div class="submit-for-candidate-line" *ngIf="submitForCandidate">
        <ng-icon name="tablerUser"></ng-icon>
        <strong>{{submitForCandidate?.firstName}} {{submitForCandidate?.lastName}}</strong>
        <span class="submit-for-candidate-id"
              *ngIf="submitForCandidate?.candidateReferenceId || submitForCandidate?.candidateId">
          ({{submitForCandidate?.candidateReferenceId || submitForCandidate?.candidateId}})
        </span>
        <span class="muted" *ngIf="submitForCandidate?.currentStatus"> · {{ getStageLabel(submitForCandidate?.currentStatus) }}</span>
      </div>

      <div class="form-group submit-for-field">
        <label>Submitted To (Upstream Business) <span class="required-star">*</span></label>
        <!-- Read-only text input pre-filled with the resolved upstream business name.
             Behind the scenes, submitForGroup.customerBusinessId still holds the
             businessId (patched in openSubmitForModal). When more than one upstream
             exists, the names are joined with " / " for display, with the form value
             defaulting to the first option's businessId. -->
        <input type="text" class="form-control input-sm submit-for-readonly"
               [value]="submitForUpstreamName" readonly tabindex="-1"/>
        <span class="error" *ngIf="submitForGroup.get('customerBusinessId')?.errors?.required && submitForGroup.get('customerBusinessId')?.touched">
          No upstream business resolved
        </span>
        <div class="muted" *ngIf="submitForUpstreamOptions.length === 0">
          No upstream business available — chain has already reached the top.
        </div>
      </div>

      <div class="submit-for-row">
        <div class="form-group submit-for-field rate">
          <label>Submitted Rate <span class="required-star">*</span></label>
          <input type="text" class="form-control input-sm" maxlength="8"
                 (keypress)="isInteger($event)"
                 formControlName="submittedRate" placeholder="Ex: 100.00"/>
          <span class="error" *ngIf="submitForGroup.get('submittedRate')?.errors?.required && submitForGroup.get('submittedRate')?.touched">
            Enter rate
          </span>
          <span class="error" *ngIf="submitForGroup.get('submittedRate')?.errors?.invalidDecimal">
            Enter valid rate
          </span>
        </div>
        <div class="form-group submit-for-field ratetype">
          <label>Rate Type <span class="required-star">*</span></label>
          <select class="form-control input-sm" formControlName="submittedRateType">
            <option value="Hourly">Hourly</option>
            <option value="Daily">Daily</option>
            <option value="Weekly">Weekly</option>
            <option value="Monthly">Monthly</option>
            <option value="Yearly">Yearly</option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="custom-panel-footer col-sm-12 p-0">
    <div class="panel-footer">
      <div class="footer-flex">
        <button class="btn btn-default" (click)="closeSubmitForModal()" [disabled]="submitForSubmitting">Cancel</button>
        <button class="btn btn-primary" (click)="confirmSubmitForUpstream()"
                [disabled]="submitForSubmitting || submitForUpstreamOptions.length === 0">
          <span *ngIf="!submitForSubmitting">Submit</span>
          <span *ngIf="submitForSubmitting">Submitting…</span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
